import PhoneInTalkOutlinedIcon from "@mui/icons-material/PhoneInTalkOutlined";
import { Box, Typography } from "@mui/material";
import { PrimaryButton } from "@components/Buttons/PrimaryButton";

const ORANGE = "#FB8E00";

interface ConfigurationsEmptyStateProps {
  onGoToPlans?: () => void;
}

export function ConfigurationsEmptyState({ onGoToPlans }: ConfigurationsEmptyStateProps) {
  return (
    <Box
      sx={{
        flex: 1,
        height: "100%",
        minHeight: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 3,
        py: 3,
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 420,
          textAlign: "center",
          border: "1.5px dashed rgba(var(--fx-surface-textrgb, 15, 23, 42), 0.1)",
          borderRadius: "16px",
          py: 5,
          px: 3,
          bgcolor: "rgba(251, 142, 0, 0.04)",
        }}
      >
        <Box
          sx={{
            width: 52,
            height: 52,
            borderRadius: "16px",
            mx: "auto",
            mb: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "rgba(251, 142, 0, 0.12)",
            color: ORANGE,
          }}
        >
          <PhoneInTalkOutlinedIcon sx={{ fontSize: 26 }} />
        </Box>

        <Typography
          sx={{
            fontSize: 16,
            fontWeight: 800,
            color: "var(--fx-surface-text, #0F172A)",
            mb: 0.75,
            letterSpacing: "-0.02em",
          }}
        >
          No number assigned yet
        </Typography>

        <Typography
          sx={{
            fontSize: 13,
            color: "var(--fx-surface-textsecondary, #64748B)",
            fontWeight: 500,
            lineHeight: 1.6,
            maxWidth: 320,
            mx: "auto",
            mb: onGoToPlans ? 2.5 : 0,
          }}
        >
          Assign a Flow Mobile number in the Plans tab to configure call flow and voice messages.
        </Typography>

        {onGoToPlans ? (
          <PrimaryButton
            variant="contained"
            fullWidth={false}
            onClick={onGoToPlans}
            sx={{
              borderRadius: "10px",
              px: 2.5,
              py: 0.9,
              fontSize: 13,
            }}
          >
            Go to Plans
          </PrimaryButton>
        ) : null}
      </Box>
    </Box>
  );
}
